import React from "react";
import {
    FilterTab,
    FilterTabContentDate,
    FilterTabsContainerDates
} from "../../customer/customerHomePageWithShiftScore/CustomerHomePageWithShiftScore.styles";
import {defaultFuturePeriods, defaultPastPeriods} from "constants/constants";

const DatePickerButtons = ({
    filters,
    setFilters,
    type = "past", // "past" or "future"
    onFilterChange,
    customPeriods = null
}) => {
    const periods = customPeriods || (type === "past" ? defaultPastPeriods : defaultFuturePeriods);

    const hasDefinedPeriod = period => {
        return ["lastWeek", "lastMonth", "nextWeek", "nextMonth"].includes(period);
    };

    const handleDateFilterChange = period => {
        const selectedPeriod = periods.find(p => p.key === period);
        if (!selectedPeriod) return;

        const {startDate, endDate} = selectedPeriod;

        const newFilters = {
            ...filters,
            period: hasDefinedPeriod(period) ? undefined : period,
            startDate,
            endDate
        };

        if (onFilterChange) {
            onFilterChange(newFilters, period);
        } else {
            setFilters(newFilters);
        }
    };

    const isPeriodActive = period => {
        const selectedPeriod = periods.find(p => p.key === period);
        if (!selectedPeriod) return false;

        if (hasDefinedPeriod(period)) {
            return (
                filters.startDate === selectedPeriod.startDate &&
                filters.endDate === selectedPeriod.endDate
            );
        }

        return filters.period === period;
    };

    return (
        <FilterTabsContainerDates>
            {periods.map(period => {
                const IconComponent = period.icon;
                return (
                    <FilterTab
                        key={period.key}
                        isActive={isPeriodActive(period.key)}
                        onClick={() => handleDateFilterChange(period.key)}
                    >
                        <FilterTabContentDate>
                            <IconComponent style={{fontSize: "14px"}} />
                            <span style={{fontSize: "14px", whiteSpace: "nowrap"}}>
                                {period.label}
                            </span>
                        </FilterTabContentDate>
                    </FilterTab>
                );
            })}
        </FilterTabsContainerDates>
    );
};

export default DatePickerButtons;
